export function getLocationOrigin(): string {
  return window.location.origin;
}
